import React from "react";
import { Layout } from "../components/Layout/Layout";
export default function NotificationsPage() {
  return (
    <Layout>
      <div className="p-8">Notifications Page</div>
    </Layout>
  );
}
